import { Action } from 'redux';
import { ContractState, ContractUnloadState } from '../../states/ContractState';
import { Contract } from '../../../models/Entities/Contracts/Contract';
import * as Functions from '../../../functions/common';

export default function ContractBaseReducer(
  state: ContractState | undefined,
  action: Action
): ContractState {
  const currentState = state ?? ContractUnloadState;
  const a: any = action;
  let CurrentContract: Contract | undefined;

  switch (a.type) {
    // GET ALL
    case 'CONTRACT_GET_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: false,
        failOnLoadingAll: false,
        error: undefined
      };
    case 'CONTRACT_GET_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.contracts || []).map((incomingContract: Contract) => {
              const existing = (currentState.list || []).find((c: Contract) => c.id === incomingContract.id);
              return existing ? { ...existing, ...incomingContract } : incomingContract;
            })
          : a.contracts
      };
    case 'CONTRACT_GET_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: a.error
      };

    // UPDATE ALL
    case 'CONTRACT_UPDATE_ALL_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingAll: true,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: false,
        error: undefined
      };
    case 'CONTRACT_UPDATE_ALL_RECEIVE_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: true,
        FailUpdatingAll: false,
        error: undefined,
        list: (currentState.list?.length ?? 0) > 0
          ? (a.contracts || []).map((incomingContract: Contract) => {
              const existing = (currentState.list || []).find((c: Contract) => c.id === incomingContract.id);
              return existing ? { ...existing, ...incomingContract } : incomingContract;
            })
          : a.contracts
      };
    case 'CONTRACT_UPDATE_ALL_FAIL_ACTION':
      return {
        ...currentState,
        isUpdatingAll: false,
        isUpdatingAllSuccess: false,
        FailUpdatingAll: true,
        error: a.error
      };

    // GET BY ID
    case 'CONTRACT_GET_BY_ID_REQUEST_ACTION':
      return {
        ...currentState,
        isLoadingOne: true,
        successLoadingOne: false,
        failOnLoadingOne: false,
        error: undefined
      };
    case 'CONTRACT_GET_BY_ID_RECEIVE_ACTION': {
      CurrentContract = (currentState.list || []).find((item: Contract) => item.id === a.contract.id);
      if (CurrentContract) {
        let auxContract: Contract = { ...CurrentContract, ...a.contract } as Contract;
        auxContract.addendums = CurrentContract.addendums;
        auxContract.commissionAgents = CurrentContract.commissionAgents;
        auxContract.commissionAgentsAssociated = CurrentContract.commissionAgentsAssociated;
        auxContract.access = CurrentContract.access;
        auxContract.concepts = CurrentContract.concepts;
        auxContract.stages = CurrentContract.stages;
        // El detalle del contrato puede no traer las asociaciones: si vienen vacías
        // se conservan las que ya tiene el store para no perder la asociación recién creada.
        if (a.contract.protocol === undefined || a.contract.protocol === null) {
          auxContract.protocol = CurrentContract.protocol;
        }
        if (a.contract.practitioners === undefined || a.contract.practitioners === null) {
          auxContract.practitioners = CurrentContract.practitioners;
        }
        CurrentContract = auxContract;
      }
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: true,
        failOnLoadingOne: false,
        error: undefined,
        list: CurrentContract
          ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contract.id), CurrentContract]
          : [a.contract]
      };
    }
    case 'CONTRACT_GET_BY_ID_FAIL_ACTION':
      return {
        ...currentState,
        isLoadingOne: false,
        successLoadingOne: false,
        failOnLoadingOne: true,
        error: a.error
      };

    // ADD
    case 'CONTRACT_ADD_REQUEST_ACTION':
      return {
        ...currentState,
        isAddingNewOne: true,
        successAddingNewOne: false,
        failOnAddingNewOne: false,
        error: undefined
      };
    case 'CONTRACT_ADD_RECEIVE_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: true,
        failOnAddingNewOne: false,
        error: undefined,
        list: [...(currentState.list || []), a.contract].sort(Functions.DynamicSort('contractNumber'))
      };
    case 'CONTRACT_ADD_FAIL_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false,
        successAddingNewOne: false,
        failOnAddingNewOne: true,
        error: a.error
      };

    // UPDATE
    case 'CONTRACT_UPDATE_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingOne: true,
        successUpdatingOne: false,
        failOnUpdatingOne: false,
        error: undefined
      };
    case 'CONTRACT_UPDATE_RECEIVE_ACTION': {
      const UpdatedContract = (currentState.list || []).find((item: Contract) => item.id === a.contract.id);
      let actionContract = a.contract as Contract;
      if (UpdatedContract) {
        actionContract.stages = UpdatedContract.stages;
        actionContract.cycles = UpdatedContract.cycles;
        actionContract.concepts = UpdatedContract.concepts;
        actionContract.branches = UpdatedContract.branches;
        actionContract.commissionConcepts = UpdatedContract.commissionConcepts;
        actionContract.addendums = UpdatedContract.addendums;
      }
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: true,
        failOnUpdatingOne: false,
        error: undefined,
        list: [...(currentState.list || []).filter((item: Contract) => item.id !== a.contract.id), actionContract]
      };
    }
    case 'CONTRACT_UPDATE_FAIL_ACTION':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: false,
        failOnUpdatingOne: true,
        error: a.error
      };

    // DELETE
    case 'CONTRACT_DELETE_REQUEST_ACTION': {
      let ContractToDelete = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (ContractToDelete) {
        ContractToDelete = { ...ContractToDelete, isDeleting: true, isDeletedSuccessfully: undefined, failOnDeleting: false, error: undefined } as any;
      }
      return {
        ...currentState,
        isDeletingOne: true,
        successDeletingOne: false,
        failOnDeletingOne: false,
        error: undefined,
        list: ContractToDelete ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId), ContractToDelete] : currentState.list
      };
    }
    case 'CONTRACT_DELETE_RECEIVE_ACTION': {
      let ContractDeleted = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (ContractDeleted) {
        ContractDeleted = { ...ContractDeleted, isDeleting: false, isDeletedSuccessfully: true, failOnDeleting: false, error: undefined } as any;
      }
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: true,
        failOnDeletingOne: false,
        error: undefined,
        list: ContractDeleted ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId)] : (currentState.list || []).filter((item: Contract) => item.id !== a.contractId)
      };
    }
    case 'CONTRACT_DELETE_FAIL_ACTION': {
      let ContractDeletedFail = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (ContractDeletedFail) {
        ContractDeletedFail = { ...ContractDeletedFail, isDeleting: false, isDeletedSuccessfully: false, failOnDeleting: true, error: a.error } as any;
      }
      return {
        ...currentState,
        isDeletingOne: false,
        successDeletingOne: false,
        failOnDeletingOne: true,
        error: a.error,
        list: ContractDeletedFail ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId), ContractDeletedFail] : currentState.list
      };
    }

    // Fee Division
    case 'CONTRACT_SET_VERIFIED_REQUEST_ACTION':
      return {
        ...currentState,
        isSettingVerified: true,
        VerifiedSetSuccessfully: false,
        FailSettingVerified: false,
        error: undefined
      };
    case 'CONTRACT_SET_VERIFIED_RECEIVE_ACTION': {
      let VerifiedContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (VerifiedContract) {
        VerifiedContract = { ...VerifiedContract, contractVerified: a.verified } as Contract;
      }
      return {
        ...currentState,
        isSettingVerified: false,
        VerifiedSetSuccessfully: true,
        FailSettingVerified: false,
        error: undefined,
        list: VerifiedContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId), VerifiedContract] : currentState.list
      };
    }
    case 'CONTRACT_SET_VERIFIED_FAIL_ACTION':
      return {
        ...currentState,
        isSettingVerified: false,
        VerifiedSetSuccessfully: false,
        FailSettingVerified: true,
        error: a.error
      };
    case 'CONTRACT_CHANGE_FEEDIVISION_REQUEST_ACTION':

      return {
        ...currentState,
        isChangingFeeDivision: true,
        FeeDivisionChangesSuccessfully: false,
        FailChangingFeeDivision: false,
        error: undefined
      };
    case 'CONTRACT_CHANGE_FEEDIVISION_RECEIVE_ACTION': {
      let NewFeeDicisionContract = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (NewFeeDicisionContract) {
        NewFeeDicisionContract = { ...NewFeeDicisionContract, feeDivision: a.feeDivision } as Contract;
      }
      return {
        ...currentState,
        isChangingFeeDivision: false,
        FeeDivisionChangesSuccessfully: true,
        FailChangingFeeDivision: false,
        error: undefined,
        list: NewFeeDicisionContract ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId), NewFeeDicisionContract] : currentState.list
      };
    }
    case 'CONTRACT_CHANGE_FEEDIVISION_FAIL_ACTION':
      return {
        ...currentState,
        isChangingFeeDivision: false,
        FeeDivisionChangesSuccessfully: false,
        FailChangingFeeDivision: true,
        error: a.error
      };

    // Clone
    case 'CONTRACT_CLONE_REQUEST_ACTION': {
      let EntityToClone = (currentState.list || []).find((item: Contract) => item.id === a.cloneInfo.contractToCloneId);
      if (EntityToClone) {
        EntityToClone = { ...EntityToClone, isCloning: true, isClonedSuccessfully: false, failOnCloning: false, error: undefined } as any;
      }
      return {
        ...currentState,
        list: EntityToClone ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.cloneInfo.contractToCloneId), EntityToClone] : currentState.list,
        error: undefined
      };
    }
    case 'CONTRACT_CLONE_RECEIVE_ACTION': {
      let EntityCloned = (currentState.list || []).find((item: Contract) => item.id === a.originalContractId);
      if (EntityCloned) {
        EntityCloned = { ...EntityCloned, isCloning: false, isClonedSuccessfully: true, failOnCloning: false, error: undefined } as any;
      }
      return {
        ...currentState,
        list: EntityCloned ? [...[...(currentState.list || []).filter((item: Contract) => item.id !== a.originalContractId), EntityCloned], a.contract] : [...(currentState.list || []), a.contract],
        error: undefined
      };
    }
    case 'CONTRACT_CLONE_FAIL_ACTION': {
      let EntityClonedFail = (currentState.list || []).find((item: Contract) => item.id === a.contractId);
      if (EntityClonedFail) {
        EntityClonedFail = { ...EntityClonedFail, isCloning: false, isClonedSuccessfully: false, failOnCloning: true, error: a.error } as any;
      }
      return {
        ...currentState,
        list: EntityClonedFail ? [...(currentState.list || []).filter((item: Contract) => item.id !== a.contractId), EntityClonedFail] : currentState.list,
        error: a.error
      };
    }

    default:
      return currentState;
  }
}
